import localStorageAvailable from "../../utils/localStorageAvailable";
import axios from "../../utils/axios";
import { enqueueSnackbar } from "notistack";

const eventsAffiliateData = async (user, eventId, logout) => {
    const storageAvailable = localStorageAvailable();
    const accessToken = storageAvailable
        ? localStorage.getItem("accessToken")
        : "";
    const config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `/service/events_service/v1/events/affliation_data/${eventId}`,
        headers: {
            authorization: `Bearer ${accessToken}`,
            user,
        }
    };
    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        if (error?.status === 401) {
            enqueueSnackbar("Un Authorized Request", {
                variant: "error",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            });
            logout();
        }
        if (error?.data === "Verification timeout") {
            return;
        }
        enqueueSnackbar(error?.data?.message, {
            variant: "error",
            anchorOrigin: {
                vertical: "top",
                horizontal: "right",
            },
        });
    }
};

export default eventsAffiliateData;
